module.exports = __webpack_public_path__ + "img/bg_au.f4604a55.jpg";